import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { itemPreview } from 'page/catalog/store/ItemPreviewStore'

export const Desc = observer(() => {
  const { item } = itemPreview.it
  const { description } = item

  return (
    <Vertical margin={[0, -16]} flex="1 1 0" scroll>
      <Typo size={13} pre wrap>
        {description}
      </Typo>
    </Vertical>
  )
})
